import React from 'react';
import T from 'prop-types';

import SubmissionsTable, { submissionsShape } from './SubmissionsTable';
import { numberWithDelimiter } from '../utils/formatters';

const PublishersSubmissions = ({ data }) => (
  <div>
    <h3 className="text-xl m-b-xs text-xxs-center">
      {numberWithDelimiter(data.pubs_total)} Publishers
    </h3>
    <p className="text-xs text-xxs-center m-b-xl">
      Avg. # of Apps per Publisher:&nbsp;
      <strong>{data.avg_apps == null ? 0 : data.avg_apps}</strong>
    </p>
    <h3 className="text-sm m-b-xs text-xxs-center">New Publishers Added</h3>
    <div className="b-b" />
    <div className="m-b">
      <SubmissionsTable data={data.pubs_submissions} />
    </div>
  </div>
);

PublishersSubmissions.propTypes = {
  data: T.shape({
    pubs_total: T.number,
    avg_apps: T.number,
    pubs_submissions: submissionsShape,
  }).isRequired,
};

export default PublishersSubmissions;
